let arrival_data5 = [
    {
        id : 16,
        imgurl : '/img/newarrival/section3_shoes1.jpg',
        brand : 'DESIGNSKIN',
        title : '그립 스탠드 카드 케이스',
        persent : '10%',
        price : '39,800',
        saleprice : '35,820',
    },
    {
        id : 17,
        imgurl : '/img/newarrival/section3_shoes2.jpg',
        brand : 'KRISTIN',
        title : 'Even_BR_sandal',
        persent : '20%',
        price : '188,000',
        saleprice : '167,150',
    },
    {
        id : 18,
        imgurl : '/img/newarrival/section3_shoes3.jpg',
        brand : 'MISOPE',
        title : '남성 소가죽 로퍼',
        persent : '35%',
        price : '139,000',
        saleprice : '89,250',
    },
    {
        id : 19,
        imgurl : '/img/newarrival/section3_shoes4.jpg',
        brand : 'DAKS ACC',
        title : '베이지 라인배색 린넨혼방 썬캡',
        persent : '14%',
        price : '118,000',
        saleprice : '100,890',
    },
]

export default arrival_data5